export default __webpack_public_path__ + "static/media/click-rate.6a253ff1.svg";